import { createContext, useContext, useState } from "react"

const TitleSectionContext = createContext({ action: null, setAction: () => {} })

export const TitleSectionProvider = ({ children }) => {
  const [action, setAction] = useState(null)
  return (
    <TitleSectionContext.Provider value={{ action, setAction }}>
      {children}
    </TitleSectionContext.Provider>
  )
}

export const useTitleSectionAction = () => useContext(TitleSectionContext)
